import React, { useContext } from 'react'
import { ResendOTPButton, InputText, ButtonLoading, HeaderPage } from '../../Simple'
import { Box, Grid, Typography } from '@mui/material'
import { waveAnimated } from '../../../assets'
import { AuthContext } from '../../../contexts/AuthContext'
import { debounce } from 'lodash'
import Lottie from 'lottie-react'

export default function VerificaEmail() {
  const { sttAuthCtx, uiControls, userInfo, actionsAuth, loadsAuth } = useContext(AuthContext)

  const debouncedVerifyEmail = debounce(async email => {
    await actionsAuth.VerificaEmail(email)
  }, 50)

  function VerificaCodEnviado() {
    // Tenho uma lista de obj com os email e createdAt, se o email for igual e o createdAt for menor que 1 minuto, retorna true
    if (sttAuthCtx.listEmails?.email) {
      //console.log('sttAuthCtx.listEmails', sttAuthCtx.listEmails)
      // Verifica se o email já foi enviado
      if (sttAuthCtx.listEmails.email === userInfo.email) {
        const now = Math.floor(Date.now() / 1000) // Tempo atual em segundos
        const elapsedTime =
          now - Math.floor(new Date(sttAuthCtx.listEmails.createdAt).getTime() / 1000)
        //console.log('elapsedTime', elapsedTime)
        if (elapsedTime < 60 && elapsedTime > 0) {
          return true
        }
      }
    }
    if (
      uiControls.emailHelperText ===
      'Você já solicitou um código, aguarde 2 minutos para solicitar novamente'
    )
      return true
    return false
  }

  const handleButtonClick = async () => {
    if (VerificaCodEnviado()) actionsAuth.authStep('codVerif')
    else await actionsAuth.EnviarCodigoEmail(userInfo.email)
  }

  return (
    <Box sx={{ height: '100%', width: '100%', py: 1.5 }}>
      <Lottie
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '30%',
          transform: 'rotate(180deg)',
        }}
        animationData={waveAnimated}
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
      />

      <HeaderPage action={() => actionsAuth.authStep('login')} />
      <Grid container sx={{ px: 1.5, width: '100%' }} gap={3}>
        {/* Botão de voltar */}

        <Typography variant='h5' textAlign='left' sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
          Qual o seu e-mail?
        </Typography>
        {/* Input de email ajustado */}
        <Grid
          item
          xs={12}
          sx={{
            marginTop: '0px',
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            height: 'auto',
          }}
        >
          <InputText
            label='E-mail'
            value={userInfo.email}
            helperText={loadsAuth === 'email' ? 'Verificando...' : uiControls.emailHelperText}
            error={
              uiControls.emailHelperText !== '' ? (!uiControls.emailValido ? true : false) : false
            }
            success={uiControls.emailValido}
            onChange={e => {
              actionsAuth.handleInputChange('email', e)
              debouncedVerifyEmail(e.target.value)
            }}
            type='text'
            autoComplete='email'
          />
          <ButtonLoading
            fullWidth
            disabled={!uiControls.emailValido}
            variant='contained'
            onClick={() => handleButtonClick()}
            loading={loadsAuth === 'login'}
          >
            {VerificaCodEnviado() ? 'Código já enviado' : 'Continuar'}
          </ButtonLoading>
          {sttAuthCtx.listEmails?.email === userInfo.email && (
            <ResendOTPButton
              seconds={60}
              createdAt={sttAuthCtx.listEmails.createdAt}
              onResend={() => actionsAuth.EnviarCodigoEmail(userInfo.email)}
              waitingText='Reenviar código em {time}'
              actionText='Reenviar código'
            />
          )}
        </Grid>
      </Grid>
    </Box>
  )
}
